import Vue from 'vue'
import _ from 'lodash'

const buildOptions = (config) => {
    return {
        animation: config.animation || true,
        container: config.container || 'body',
        content: config.content || '',
        delay: config.delay || 0,
        html: config.html || false,
        placement: config.placement || 'top',
        // selector: config.selector || false,
        // template: config.template || '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
        template: config.template || '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
        title: config.title || '',
        trigger: config.trigger || 'hover'
    }
}

Vue.directive('pml-popover', {
    bind (el, binding) {
        let config = _.isString(binding.value) ? buildOptions({ content: binding.value }) : buildOptions(binding.value)

        window.jQuery(el).popover(config)
    },
    update (el, binding) {
        let config = _.isString(binding.value) ? buildOptions({ content: binding.value }) : buildOptions(binding.value)

        window.jQuery(el).popover(config)
    },
    unbind (el) {
        window.jQuery(el).popover('destroy')
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/popover.js